module.exports = __webpack_public_path__ + "static/media/swz.7cb1d7b5.svg";